
import React from 'react';

const BlogPage = () => {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-3xl font-bold mb-6">Restaurant Management Blog</h1>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div key={item} className="border rounded-lg overflow-hidden shadow-sm">
            <div className="h-48 bg-muted"></div>
            <div className="p-4">
              <h2 className="text-xl font-semibold mb-2">Restaurant Management Tips</h2>
              <p className="text-muted-foreground">
                Learn how to efficiently manage your restaurant operations and increase profitability.
              </p>
              <div className="mt-4">
                <a href="#" className="text-primary hover:underline">Read more</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
